<template>
  <portal to="portal-render" v-if="showOverlay">
    <div class="checkout-overlay" :class="type" transition-name="opacity" v-if="showOverlay">
      <div class="checkout-overlay-wrapper" :style="overlayStyles">
        <div class="checkout-overlay-content" :class="contentClasses">
          <slot></slot>

          <button class="checkout-overlay-close" @click="$emit('update:show-overlay', false)" v-if="enableClose">
            <svg-loader :src="`/assets/images/${closeIcon}`" inline></svg-loader>
          </button>
        </div>
      </div>

      <clickout-overlay @click.native="$emit('update:show-overlay', false)" v-if="enableClose"></clickout-overlay>
    </div>
  </portal>
</template>

<script>
  import ClickoutOverlay from 'core/components/ClickoutOverlay/ClickoutOverlay'

  export default {
    name: 'checkout-overlay',
    components: {
      ClickoutOverlay
    },
    data: () => ({
      showContent: false
    }),
    props: {
      showOverlay: Boolean,
      enableClose: Boolean,
      type: String,
      minHeight: String
    },
    computed: {
      closeIcon () {
        return this.type === 'full' ? 'icon-canvas-close.svg' : 'builder-form-close.svg'
      },
      overlayTransition () {
        return 'fade'
      },
      contentClasses () {
        return {
          'active': this.showContent
        }
      },
      overlayStyles () {
        return {
          'min-height': this.minHeight
        }
      }
    },
    watch: {
      showOverlay (newValue) {
        if (newValue) {
          this.showOverlayContent()
        } else {
          this.hideOverlayContent()
        }
      }
    },
    methods: {
      showOverlayContent () {
        this.$emit('update:show-overlay', true)

        window.setTimeout(() => {
          this.showContent = true
        }, 300)

        if (this.enableClose) {
          window.addEventListener('keyup', ($event) => {
            if ($event.keyCode === 27) {
              this.$emit('update:show-overlay', false)
            }
          })
        }
      },
      hideOverlayContent () {
        this.$emit('update:show-overlay', false)
        this.showContent = false

        if (this.enableClose) {
          window.removeEventListener('keyup', ($event) => {
            if ($event.keyCode === 27) {
              this.$emit('update:show-overlay', false)
            }
          })
        }
      },
      showCheck () {
        if (this.showOverlay) {
          this.showOverlayContent()
        } else {
          this.hideOverlayContent()
        }
      }
    },
    mounted () {
      this.showCheck()
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay {
    @include fade-transition;
    @include opacity-transition;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    pointer-events: all;

    &.full {
      background: none;

      .checkout-overlay-wrapper {
        width: 100%;
        height: 100%;
        background-color: $color-dark-grey;
      }

      .checkout-overlay-content {
        overflow: auto;
        background: none;

        &:before {
          box-shadow: none;
        }
      }

      .checkout-overlay-close {
        width: 30px;
        height: 30px;
        position: fixed;

        svg {

          path {
            fill: #4a4a4a;

            &:last-child {
              fill: #fff;
            }
          }
        }
      }
    }

    &.platform {
      background: rgba(#000, .7);

      .checkout-overlay-wrapper {
        width: auto;
        min-width: 38vw;
        height: auto;
        min-height: 200px;
        max-height: 100%;
        display: flex;
      }

      .checkout-overlay-content {
        width: 100%;
        padding: 25px 30px;
        padding: 0;
        background-color: #F9F9F9;
        border-radius: 3px;
        color: #4a4a4a;

        &:before {
          content: none;
        }
      }

      .checkout-overlay-close {
        width: 30px;
        height: 30px;
        top: 15px;
        right: 15px;

        svg {
          path {
            fill: rgba(#fff, .6)
          }

          path + path {
            fill: #000;
          }
        }
      }
    }
  }

  .checkout-overlay-close {
    @include clear-button;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .checkout-overlay-wrapper {
    width: 400px;
    height: 400px;
    z-index: 60;
  }

  .checkout-overlay-content {
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: $color-marine;
    box-shadow: 0 11px 15px -7px rgba(#000, .2),
                0 24px 38px 3px rgba(#000, .14),
                0 9px 46px 8px rgba(#000, .12);
    color: #fff;
  }
</style>
